import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Hidden } from '@material-ui/core';
import UDFDataField from '../CalendarControls/UDFDataField';
import { actionUpdateMemberUDF } from 'actions';

const { MembershipUDFsHeading } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px'
    },
    largetourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '60px'
    },
    removeFontSize: {
        fontSize: 'initial !important'
    }
}));

const MembershipUDF = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const membershipTypesUdfs = useSelector(state => state.reducerMembershipUserDefinedFields);

    const onChangeHandler = (event, bookingID, categoryName, udfID) => {
        let udfValue = '';
        if (event.target.type != undefined && event.target.type == "checkbox")
            udfValue = event.target.checked;
        else
            udfValue = event.target.value;
        actionUpdateMemberUDF(dispatch, props.MembershipTypeID, props.userNo, categoryName, udfID, udfValue);
    }

    return (
        <div>
            <Grid container>
                {membershipTypesUdfs.membershipUdfs && membershipTypesUdfs.membershipUdfs.length > 0 &&
                    membershipTypesUdfs.membershipUdfs.filter(x => x.MembershipTypeID === props.MembershipTypeID).length > 0 ?
                    membershipTypesUdfs.membershipUdfs.filter(x => x.MembershipTypeID === props.MembershipTypeID)[0].UDFCategories != null &&
                    membershipTypesUdfs.membershipUdfs.filter(x => x.MembershipTypeID === props.MembershipTypeID)[0].UDFCategories.map((udfCategorey, i) => (

                        <Card style={{ borderRadius: "0", width: "100%" }}>
                            <CardHeader className={classes.tourheaderbox}
                                title={udfCategorey.UDFCategoryName}
                                titleTypographyProps={{ color: "inherit" }}
                            />
                            <CardContent>


                                {udfCategorey.UserDefinedFields.map((udfs) => (
                                    <Grid container lg={12} sm={12} xs={12}>
                                        <Grid item lg={7} sm={7} xs={7} align="left">
                                            <Hidden smDown >
                                                <Typography variant="h4" style={{ padding: "5px" }} className={classes.removeFontSize}>
                                                    {udfs.UDFDescription} {udfs.IsRequired ? '(required)' : ''}
                                                </Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp >
                                                <Typography variant="h5" style={{ padding: "5px" }} className={classes.removeFontSize}>
                                                    {udfs.UDFDescription} {udfs.IsRequired ? '(required)' : ''}
                                                </Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="h5" style={{ padding: "5px" }} className={classes.removeFontSize}>
                                                    {udfs.UDFDescription} {udfs.IsRequired ? '(required)' : ''}
                                                </Typography>
                                            </Hidden>
                                        </Grid>

                                        <Grid item lg={5} sm={5} xs={5} align="left">
                                            <UDFDataField key={udfs.UDFID + "_" + props.MembershipTypeID + "_" + props.userNo} isMembership={true} usernumber={props.userNo} bookingID={0} udf={udfs} changecontrolvalue={onChangeHandler} />
                                        </Grid>
                                    </Grid>
                                ))}
                            </CardContent>
                        </Card>
                    )) : null}

            </Grid>

        </div >
    )
};

export default MembershipUDF;
